import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { Accessibility } from './accessibility'
import { AccessibilitySite } from './accessibilitySite'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(LifeCycle.PageDidMountHandler).to(Accessibility)
	}
}

export const site: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(LifeCycle.AppDidMountHandler).to(AccessibilitySite)
	}
}

export { config } from './configs'
